<span class="sd-resident-basic-label" *ngIf="claimStatusCode === ClaimStatusCode.submitted"
    title="Resident Status">Submitted</span>

<span class="sd-resident-warning-label" *ngIf="claimStatusCode === ClaimStatusCode.informationRequested"
    title="Resident Status">Information Requested</span>
<span class="sd-resident-warning-label" *ngIf="claimStatusCode === ClaimStatusCode.underReview"
    title="Resident Status">Under Review</span>
<span class="sd-resident-info-label" *ngIf="claimStatusCode === ClaimStatusCode.approved"
    title="Resident Status">Approved</span>

<span class="sd-resident-info-label" *ngIf="claimStatusCode === ClaimStatusCode.partiallyApproved"
    title="Resident Status">Partially Approved</span>

<span class="sd-resident-info-label" *ngIf="claimStatusCode === ClaimStatusCode.pendingPayment"
    title="Resident Status">Pending Payment</span>

<span class="sd-resident-success-label" *ngIf="claimStatusCode === ClaimStatusCode.paidOut"
    title="Resident Status">Paid Out</span>

<span class="sd-resident-error-label" *ngIf="claimStatusCode === ClaimStatusCode.declined"
    title="Resident Status">Declined</span>

<span class="sd-resident-error-label" *ngIf="claimStatusCode === ClaimStatusCode.archived"
    title="Resident Status">Archived</span>

<span class="sd-resident-error-label" *ngIf="claimStatusCode === ClaimStatusCode.deleted"
    title="Resident Status">Deleted</span>